import { useState, useContext, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import ExperienceContext from "./ExperienceContext";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
import {
	Image,
	TextInput,
	Group,
	Button,
	Modal,
	Tabs,
	Input,
	Container,
	Loader,
	Grid,
	ScrollArea,
	Text,
	Pagination,
} from "@mantine/core";
import uploadIcon from "../../static/svg/upload.svg";
import uploadMedia from "../../API/uploadMedia";
import { getAssets } from "../../API/getAssets";
import { CDN_URL } from "../../constant";
function AddPanoSpotModal({ isPanoSpotOpen, setIsPanoSpotOpen, activePanoId }) {
	const user = useSelector((state) => state.userInformationReducer.users);
	const { addPanoSpot } = useContext(ExperienceContext);
	const fileInput = useRef(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [name, setName] = useState("");
	const [recentPanoromas, setRecentPanoromas] = useState("");
	const [pages, setPages] = useState(1);
	const [activePage, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [activeTab, setActiveTab] = useState("Upload");
	const handleFileUpload = (event) => {
		setUploadedFile(event.target.files[0]);
	};
	const handleCreate = async () => {
		setLoading(true);
		if (name === "") {
			showErrorNotification("Panorama name cannot be empty");
			setLoading(false);
			return;
		} else if (!uploadedFile) {
			showErrorNotification("Please upload an image");
			setLoading(false);
			return;
		}
		const formData = new FormData();
		formData.append("myfile", uploadedFile);
		formData.append(
			"bodyData",
			JSON.stringify({
				UserId: user?.UserId,				
				AccountId: user?.AccountId,
				Name: name,
				AssetTypeId: 4,
			})
		);
		const result = await uploadMedia(formData);

		if (result.status === 201) {
			addPanoSpot(
				activePanoId,
				result.data.res.LocationUrl,
				result.data.res.PreviewUrl,
				name
			);
			showSuccessNotification("Panorama uploaded");
		} else {
			showErrorNotification("Panorama not uploaded");
		}
		setUploadedFile(null);
		setName("");
		setIsPanoSpotOpen(false);
		setLoading(false);
	};

	const addFromRecent = (pano) => {
		addPanoSpot(activePanoId, pano.LocationUrl, pano.PreviewUrl, pano.Name);
		setUploadedFile(null);
		setName("");
		setIsPanoSpotOpen(false);
	};

	useEffect(() => {
		const recentMedia = async () => {
			const result = await getAssets(user?.UserId, activePage, 4, 10);
			setRecentPanoromas(result.data);
			setPages(result.totalPages);
		};
		recentMedia();
	}, [activePage]);
	return (
		<Modal
			centered
			size="lg"
			opened={isPanoSpotOpen}
			onClose={() => {
				setName("");
				setUploadedFile(null);
				setIsPanoSpotOpen(false);
			}}
			title="Add Panorama Spot"
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			}}
		>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
			<Tabs
				value={activeTab}
				onTabChange={setActiveTab}
				style={{ borderBottom: "none !important" }}
				styles={{
					tabsListWrapper: { borderBottom: "none !important" },
					tabsList: { borderBottom: "none !important" },
				}}
			>
				<Tabs.List>
					<Tabs.Tab
						value="Upload"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Upload
					</Tabs.Tab>
					<Tabs.Tab
						value="Recent"
						sx={{
							"&:hover": {
								backgroundColor: "inherit",
								borderBottom: "none",
							},
						}}
					>
						Recent
					</Tabs.Tab>
				</Tabs.List>
				<Tabs.Panel value="Upload" pt="xs">
					<Container style={{ width: "100%", minHeight: "300px" }}>
						<TextInput
							my={5}
							label="Spot Name"
							variant="filled"
							placeholder="Enter image description"
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
									fontWeight: "700",
								},
							}}
							value={name}
							onChange={(event) =>
								setName(event.currentTarget.value)
							}
						/>
						{uploadedFile === null ? (
							<>
								<label
									htmlFor="file-input"
									style={{
										display: "flex",
										width: "100%",
										height: "100%",
										minHeight: "300px",
										alignItems: "center",
										justifyContent: "center",
										flexDirection: "column",
										gap: "10px",
										border: "1px solid #09254E",
										borderRadius: "5px",
										cursor: "pointer",
									}}
								>
									<Image src={uploadIcon} width={75} />
									<Button
										variant="outline"
										my={10}
										px={30}
										size="xs"
										radius={"md"}
										sx={(theme) => ({
											color: theme.colors.white[0],
											borderColor:
												theme.colors.ivisit_light[0],
										})}
										onClick={() => {
											fileInput.current.click();
										}}
									>
										Browse
									</Button>
								</label>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".jpg, .jpeg, .png"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						) : (
							<Image
								height={220}
								src={URL.createObjectURL(uploadedFile)}
								fit="contain"
							/>
						)}
					</Container>
				</Tabs.Panel>
				<Tabs.Panel value="Recent" pt="xs">
					Use recent Panoramas
					<ScrollArea
						mt={10}
						style={{ height: 300 }}
						type="auto"
						offsetScrollbars
						scrollbarSize={8}
						scrollHideDelay={500}
					>
						<Grid style={{ minHeight: 270 }}>
							{recentPanoromas &&
								recentPanoromas.map((item) => {
									return (
										<Grid.Col
											span={3}
											key={item.id}
											onClick={() => {
												addFromRecent(item);
											}}
										>
											<a
												style={{
													cursor: "pointer",
													display: "flex",
													flexDirection: "column",
												}}
											>
												<img
													alt="RecentPanoramas"
													style={{
														width: "100%",
														height: "80px",
													}}
													src={
														CDN_URL +
														item.PreviewUrl
													}
												/>
												<p
													style={{
														textAlign: "center",
														textOverflow:
															"ellipsis",
														whiteSpace: "nowrap",
														fontSize: "10px",
														marginTop: "3px",
														overflow: "hidden",
													}}
												>
													{item.Name}
												</p>
											</a>
										</Grid.Col>
									);
								})}
						</Grid>
						{pages !== 1 && (
							<Pagination
								sx={{
									Button: {
										background: "#09254E",
										fontWeight: "600",
										padding: "0px 4px",
										fontSize: "12px",
										border: "none",
									},
									"Button:first-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
									"Button:last-child": {
										backgroundColor: "#14B8E1",
										border: "none",
									},
								}}
								page={activePage}
								onChange={setPage}
								mt={5}
								total={pages}
								size="xs"
								style={{
									justifyContent: "center",
									color: "pink",
								}}
							/>
						)}
					</ScrollArea>
				</Tabs.Panel>
			</Tabs>

			<Group style={{ width: "100%", justifyContent: "space-between" }}>
				<Group
					style={{
						width: "auto",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						color: "#a4bac6",
						opacity: "0.5",
					}}
				>
					<Text
						size="xs"
						backgroundColor="red"
						color="white"
						style={{ lineHeight: "0px", marginTop: "15px" }}
					>
						{" "}
						Make sure your file size is under 3 MB.
					</Text>
					<Text size="xs" color="white" style={{ lineHeight: "0px" }}>
						Learn More about our platform supported formats and
						restrictions.
					</Text>
				</Group>
				<Group
					style={{
						width: "auto",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={() => {
							setName("");
							setUploadedFile(null);
							setIsPanoSpotOpen(false);
						}}
					>
						Cancel
					</Button>
					<Button
						variant="outline"
						my={0}
						px={25}
						size="xs"
						radius={"md"}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={handleCreate}
					>
						Create
					</Button>
				</Group>
			</Group>
		</Modal>
	);
}

export default AddPanoSpotModal;
